// This function can be used with both gatsby-node and in components and ensures
// that the paths are created the same way during the build and in the frontend.

const traverseExperienceSlugs = experience => {
  if (!experience.slug) {
    console.log('Error at:', experience, typeof experience);
    throw new Error('When creating paths all elements must have a slug. Are you sure your graph contains all slugs?');
  }

  return [
    experience.parent
      ? traverseExperienceSlugs(experience.parent.find(({ slug }) => slug.indexOf('home') < 0) || experience.parent[0])
      : null, // hack                             ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
    experience.slug,
  ];
};

const getExperiencePath = experience => {
  let path = traverseExperienceSlugs(experience)
    .flat(4)
    .join('/');
  if (path.indexOf('/experience') !== 0) {
    path = `/experience/other${path}`;
  }
  return path;
};

module.exports.getExperiencePath = getExperiencePath;
